import script from "./ConfirmAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmAddress.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmAddress.vue?vue&type=style&index=0&id=5da2a917&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5da2a917"]])

export default __exports__